module.exports = __webpack_public_path__ + "static/media/ieee_tunisia_white.b716f15d.png";